import client from "@/client/publicApiClient.ts";
import { useMutation } from "@tanstack/react-query";
import type { SignUpInviteMutationRequest, SignUpInviteMutationResponse, SignUpInvitePathParams, SignUpInvite400 } from "../types/SignUpInvite";
import type { UseMutationOptions } from "@tanstack/react-query";

 type SignUpInviteClient = typeof client<SignUpInviteMutationResponse, SignUpInvite400, SignUpInviteMutationRequest>;
type SignUpInvite = {
    data: SignUpInviteMutationResponse;
    error: SignUpInvite400;
    request: SignUpInviteMutationRequest;
    pathParams: SignUpInvitePathParams;
    queryParams: never;
    headerParams: never;
    response: SignUpInviteMutationResponse;
    client: {
        parameters: Partial<Parameters<SignUpInviteClient>[0]>;
        return: Awaited<ReturnType<SignUpInviteClient>>;
    };
};
/**
 * @summary Accept invitation
 * @link /:token
 */
export function useSignUpInvite(token: SignUpInvitePathParams["token"], options: {
    mutation?: UseMutationOptions<SignUpInvite["response"], SignUpInvite["error"], SignUpInvite["request"]>;
    client?: SignUpInvite["client"]["parameters"];
} = {}) {
    const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};
    return useMutation({
        mutationFn: async (data) => {
            const res = await client<SignUpInvite["data"], SignUpInvite["error"], SignUpInvite["request"]>({
                method: "post",
                url: `/${token}`,
                data,
                headers: { "Content-Type": "text/json", ...clientOptions.headers },
                ...clientOptions
            });
            return res.data;
        },
        ...mutationOptions
    });
}